import { apiUrls } from '../../constants/apiUrls';
import { getExperienceInitCookie } from './experienceInitCookie';
import axiosExternal from 'axios';
import { getCurrentLocale } from './cookies';

export interface CandidateMessages {
  welcomePageContent: string;
  welcomePageHeading: string;
  taskListPageContent: string;
  taskListPageHeading: string;
  endPageContent: string;
  endPageHeading: string;
  manualHurdleContent: string;
  manualHurdleHeading: string;
  hurdleFailHeading: string;
  hurdleFailContent: string;
}

interface CandidateMessagesResponse {
  code: number;
  data: CandidateMessages;
}

interface CandidateMessagesPayload {
  tpodId?: number;
  companyUserId?: number;
  languageCode: string;
}

export const psuedoResponse: CandidateMessagesResponse = {
  code: 0,
  data: {
    welcomePageHeading: '',
    welcomePageContent: '',
    taskListPageContent: '',
    endPageContent: '',
    manualHurdleContent: '',
    manualHurdleHeading: '',
    hurdleFailHeading: '',
    hurdleFailContent: '',
    endPageHeading: '',
    taskListPageHeading: '',
  },
};
export const getCandidateMessages = async (): Promise<CandidateMessagesResponse> => {
  const expCookie = getExperienceInitCookie();
  const tpodId = expCookie && expCookie.tpodId;
  const companyUserId = expCookie && expCookie.companyUserId;

  const candidateMessagesPayload: CandidateMessagesPayload = {
    languageCode: getCurrentLocale(),
  };

  if (tpodId) candidateMessagesPayload.tpodId = tpodId;
  else candidateMessagesPayload.companyUserId = companyUserId;

  try {
    const { data: responseData } = await axiosExternal.get(apiUrls.GET_CANDIDATE_MESSAGES, {
      params: candidateMessagesPayload,
      headers: { 'X-Api-AuthToken': process.env.REACT_APP_API2_AUTH_TOKEN },
    });
    return responseData;
  } catch (e) {
    console.error('error while fetching candidate messages', e);
  }
  return psuedoResponse;
};
